import React from 'react';
import { Tooltip, Button } from 'antd';
import styles from './Btn.module.scss';

const Btn = ({
  tooltipTitle,
  tooltipPlacement = 'topRight',
  onClick,
  children,
  ...props
}) => {
  return (
    <Tooltip
      title={tooltipTitle}
      placement={tooltipPlacement}
    >
      <Button
        {...props}
        className={styles.root}
        onClick={onClick}
      >
        {children({ className: styles.icon })}
      </Button>
    </Tooltip>
  );
};

export default Btn;
